<template>
  <div class="container zeropadding">
    <div class="row" v-if="msg">
      <div class="col bg-info rounded">{{ msg }}</div>
    </div>
    <div class="row">
      <div class="col">
        <ul class="list-group" v-if="sorted_bids.length">
          <li
            class="list-group-item smalltxt"
            v-for="(b, index) in sorted_bids"
            :key="b.id"
          >
            <div class="row d-flex align-items-center">
              <div class="col">
                <LogoSmall :path="getPath(b.team_id)"></LogoSmall>
              </div>
              <div class="col" @click="showSaleButton(b.id)">
                {{ getName(b.team_id) }}
              </div>
              <div
                class="col-3 d-flex justify-content-between align-items-center"
              >
                <span
                  v-if="edit_bid_id != b.id"
                  @click="toggleEditAmount(b.amount, b.id, b.team_id)"
                  class="border rounded padding3"
                  >{{ formatToIndianCurrency(b.amount) }}</span
                >
                <span v-else>
                  <input
                    type="text"
                    class="form-control smalltxt border-2 border-primary"
                    placeholder="Edit"
                    v-model.number="new_bid_amount"
                    @keyup.enter="editBidAmount(b.amount)"
                  />
                </span>
                <i
                  class="bi bi-chevron-down float-start"
                  @click="toggleExpand()"
                  v-if="index == 0 && !expand_bids"
                ></i>
                <i
                  class="bi bi-chevron-up float-start"
                  @click="toggleExpand()"
                  v-if="index == 0 && expand_bids"
                ></i>
              </div>
              <!-- <div class="col">{{ formatTo24HourTime(b.created_at) }}</div> -->
              <div class="col-1 text-danger">
                <span v-if="index == 0">
                  <CountDown
                    :tz="b.created_at"
                    @execute-sale="executeSale(b.team_id, b.amount)"
                  ></CountDown
                ></span>
              </div>
              <div class="col">
                <button
                  class="btn btn-sm btn-primary salebutton"
                  v-if="index == 0"
                  @click="executeSale(b.team_id, b.amount)"
                >
                  Sale
                </button>
              </div>
            </div>
            <div class="row p-2" v-if="sale_bid_id == b.id">
              <div class="col">
                <i
                  class="bi bi-trash text-danger"
                  v-if="!allow_delete"
                  @click="toggleDelete()"
                ></i>
                <span
                  v-else
                  @click="toggleDelete()"
                  class="float-end border rounded bg-success text-white"
                  >Cancel</span
                >

                <span
                  class="float-start text-danger border rounded bg-danger text-white"
                  v-if="allow_delete"
                  @click="deleteBid(b.id)"
                  >Yes, delete bid.
                </span>
              </div>
            </div>
          </li>
        </ul>
        <span v-else class="border rounded bg-info p-1 mt-1 fw-bold">
          Awaiting bids...
        </span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, onMounted, ref, computed, watchEffect } from "vue";
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
import LogoSmall from "../../bidder/logos/LogoSmall.vue";
import CountDown from "./CountDown.vue";
const props = defineProps(["player_id"]);
const store = useStore();
const bids_list = ref([]);
const team_icon_list = ref([]);
const sale_bid_id = ref("");
const allow_delete = ref(false);
const expand_bids = ref(false);
const timer = ref(0);
const new_bid_amount = ref(0);
const edit_bid_id = ref("");
const team_players = ref([]);
const team_data = ref({});
const auction_data = ref({});
const auction = ref({});
const editBidAmount = async (original_amount) => {
  if (edit_bid_id.value && checkIfBidAmountOK(original_amount)) {
    const { data, error } = await supabase
      .from("bids")
      .update({ amount: new_bid_amount.value })
      .eq("id", edit_bid_id.value)
      .select();
    if (!error) {
      msg.value = "Bid updated!";
      edit_bid_id.value = "";
      new_bid_amount.value = 0;
    }
  } else {
    msg.value = "Bid amount error!";
  }
  setTimeout(() => {
    msg.value = "";
  }, 1500);
};
const checkIfBidAmountOK = (original_amount) => {
  var purchased_count = 0;
  team_players.value.forEach((p) => {
    if (p.team_id == team_data.value.id && p.sale_price) {
      //done to count only purchased players, not core team
      purchased_count++;
    }
  });
  //var purchased_count = team_players.value.length;
  var bid_ok = true;
  const team_size = auction_data.value.to_purchase;
  const max_bid =
    team_data.value.wallet -
    (team_size - purchased_count - 1) * auction_data.value.base_price;
  if (new_bid_amount.value > max_bid) {
    bid_ok = false;
  }
  if (new_bid_amount.value % auction_data.value.bid_increment) {
    bid_ok = false;
  }
  if (new_bid_amount.value == 0) {
    bid_ok = false;
  }
  if (!bid_ok) {
    //reset the bid amount to original amount if error
    new_bid_amount.value = original_amount;
  }
  return bid_ok;
};
const toggleEditAmount = (bid_amount, bid_id, team_id) => {
  if (edit_bid_id.value != bid_id) {
    edit_bid_id.value = bid_id;
    new_bid_amount.value = bid_amount;
    fetchTeamData(team_id);
  } else {
    edit_bid_id.value = "";
    new_bid_amount.value = 0;
  }
};
const fetchTeamData = async (team_id) => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("id", team_id);
  team_data.value = teams[0];
  let { data: players, error_ } = await supabase
    .from("players")
    .select("*")
    .eq("team_id", team_id);
  team_players.value = players;
  let { data: auctions, err } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction_data.value = auctions[0];
};
const toggleExpand = () => {
  expand_bids.value = !expand_bids.value;
};
const msg = ref("");
const executeSale = async (team_id, amount) => {
  haltBidding(true); //block out bid buttons from users
  if (checkWalletBalance(team_id, amount)) {
    const { data, error } = await supabase
      .from("players")
      .update({ team_id: team_id, sale_price: amount, sold_at: "now()" })
      .eq("id", props.player_id)
      .select();
    if (!error) {
      deductWallet(team_id, amount);
      msg.value = "Completing sale...";
      setTimeout(() => {
        msg.value = msg.value + "done!";
      }, 1000);
      setTimeout(() => {
        if (!auction.value.select_live_player) {
          store.saleAction("sale-done-show-next-player");
        } else {
          //in player selection mode - next player is NOT automatically made live.
          store.saleAction("sale-done-clear-live-player");
        }
        msg.value = "";
      }, 3000);
    } else {
      msg.value = error.message;
    }
  } else {
    msg.value = "Insufficient balance!";
    setTimeout(() => {
      msg.value = "";
    }, 1000);
  }
};
const haltBidding = async (bool) => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ halt_bidding: bool })
    .eq("id", store.live_auction)
    .select();
};
const checkWalletBalance = async (team_id, amount) => {
  var wallet_ok = false;
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("id", team_id);
  if (teams[0].wallet >= amount) {
    wallet_ok = true;
  }
  return wallet_ok;
};
const deductWallet = async (team_id, amount) => {
  var new_wallet = 0;
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("id", team_id);
  new_wallet = teams[0].wallet - amount;
  const { data_, error_ } = await supabase
    .from("teams")
    .update({ wallet: new_wallet })
    .eq("id", team_id)
    .select();
};
const toggleDelete = () => {
  allow_delete.value = !allow_delete.value;
};
onMounted(() => {
  setTimeout(() => {
    fetchBids();
    fetchTeamLogoList();
    fetchAuction();
  }, 500);
});
const fetchAuction = async () => {
  let { data: auctions, err } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
};
const fetchBids = async () => {
  let { data: bids, error } = await supabase
    .from("bids")
    .select("*")
    .eq("player_id", props.player_id);
  bids_list.value = bids;
  setupBidsListner();
  setupDeleteListner();
};
const setupDeleteListner = () => {
  const channels = supabase
    .channel("auctioneer-bids-delete-channel")
    .on(
      "postgres_changes",
      { event: "DELETE", schema: "public", table: "bids" },
      (payload) => {
        // console.log("Delete Listner=>", payload);
        var del_id = payload.old.id;
        bids_list.value = bids_list.value.filter((bid) => bid.id !== del_id);
      }
    )
    .subscribe();
};
const setupBidsListner = () => {
  // payload.eventType:"INSERT"
  const channels = supabase
    .channel("auctioneer-bids-listner-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "bids",
        filter: `player_id=eq.${props.player_id}`,
      },
      (payload) => {
        //console.log("Change received!", payload);
        //console.log(payload.eventType);
        bids_list.value = [];
        fetchBids();
      }
    )
    .subscribe();
};
function formatTo24HourTime(timestamp) {
  const date = new Date(timestamp);
  const hours = String(date.getHours()).padStart(2, "0"); // 0–23
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}
const fetchTeamLogoList = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("id, name, icon")
    .eq("auction_id", store.live_auction);
  team_icon_list.value = teams;
};
const sorted_bids = computed(() => {
  var arr = [];
  bids_list.value.forEach((b) => {
    arr.push(b);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => b.amount - a.amount);
  if (!expand_bids.value) {
    sorted_arr = sorted_arr.slice(0, 1);
  }
  return sorted_arr;
});
const getPath = (id) => {
  var path = "";
  team_icon_list.value.forEach((i) => {
    if (i.id == id) {
      path = i.icon;
    }
  });
  return path;
};
const getName = (id) => {
  var name = "";
  team_icon_list.value.forEach((i) => {
    if (i.id == id) {
      name = i.name;
    }
  });
  return name;
};
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
const showSaleButton = (id) => {
  allow_delete.value = false;
  if (sale_bid_id.value != id) {
    sale_bid_id.value = id;
  } else {
    sale_bid_id.value = "";
  }
};
const deleteBid = async (id) => {
  const { error } = await supabase.from("bids").delete().eq("id", id);
  if (!error) {
    msg.value = "Bid deleted!";
    //fetchBids();
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};
const setBiddingOpenToFalse = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: false })
    .eq("id", store.live_auction)
    .select();
};
// JS
function startCountdown(createdAt) {
  const timerEl = document.getElementById("timer");
  const createdTime = new Date(createdAt).getTime();
  const now = Date.now();
  const elapsedSeconds = Math.floor((now - createdTime) / 1000);
  let remaining = 10 - elapsedSeconds;

  if (remaining <= 0) {
    timerEl.textContent = "sold";
    return;
  }

  timerEl.textContent = remaining;

  const interval = setInterval(() => {
    remaining--;
    if (remaining <= 0) {
      clearInterval(interval);
      timerEl.textContent = "sold";
    } else {
      timerEl.textContent = remaining;
    }
  }, 1000);
}

// Example usage with a Supabase created_at timestamp:
</script>
<style scoped>
.smalltxt {
  padding: 3px;
  font-size: 12px;
}
.salebutton {
  padding: 1px;
  font-size: 10px;
}
.zeropadding {
  padding: 0px;
}
.padding3 {
  padding: 3px;
}
</style>
